module.exports = __webpack_public_path__ + "static/img/otLogo.f58aa33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/otLogo.png
// module id = kCkG
// module chunks = 44